export const state = () => ({
  account: {}
})

export const mutations = {
  setAccount(state, user) {
    state.account = user
  }
}

export const actions = {
  async fetchAccount(state) {
    const account = this.$http.$get('https://api.selectel.ru/v1/account', {credentials: 'include'})
    state.commit('setAccount', account)
  }
}

export const getters = {
  accountInfo(state) {
    return state.account
  },
  accountEmail(state) {
    return state.account.email
  }
}